import { paymentThunk, getSubsciptionHistoryThunk } from '../../../../../store/workspace/thunks';
import { setConfirmCancelSubscriptionModal } from '../../../../../store/workspace/slice';
import { setNotification } from '../../../../../store/general/slice';
import { CancelPlanSquareIcon } from '../../../../../assets/icons';
import CheckBox from '../../../../../components/CheckBox';
import { useDispatch } from '../../../../../store/store';
import { CancelReason } from '../../types';
import styles from './style.module.scss';
import Modal from '../../../../../components/Modal';
import Input from '../../../../../components/Input';
import { useState } from 'react';
import {
    OTHER_REASON_ID,
    CANCELLATION_REASONS,
} from '../../constants';

/** Asks why the owner is leaving, then cancels at the end of the billing cycle. */
export default function ConfirmCancelSubscription() {
    const dispatch = useDispatch();
    const [error, setError] = useState('');
    const [comment, setComment] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [selectedReason, setSelectedReason] = useState<CancelReason | null>(null);

    const isOtherReason = selectedReason?.id === OTHER_REASON_ID;
    const closeModal = () => dispatch(setConfirmCancelSubscriptionModal(false));

    const confirm = () => {
        if (!selectedReason) return;

        setIsLoading(true);
        setError('');

        /** "Other" carries no information on its own, the comment is the reason. */
        dispatch(paymentThunk({
            action: 'cancel_subscription',
            reason: isOtherReason ? comment.trim() : selectedReason.text,
        }))
            .unwrap()
            .then(() => {
                closeModal();
                dispatch(getSubsciptionHistoryThunk({ action: 'get_subscription_status' }));
            })
            .catch(error => {
                const message = error?.message || 'Something went wrong,Please try again.';
                setError(message);
                dispatch(setNotification([message, 'error']));
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <Modal
            size='sm'
            actions='both'
            title='Cancel plan'
            closeFunc={closeModal}
            childClassName={styles.wrapper}
            icon={<CancelPlanSquareIcon />}
            dismissButton={{
                text: 'Cancel',
                type: 'Outline-Primary',
                onClick: closeModal,
            }}
            confirmButton={{
                text: 'Confirm',
                type: 'Error',
                onClick: confirm,
                loading: isLoading,
                disabled: !selectedReason || (isOtherReason && !comment),
            }}
        >
            <div className={styles.text}>
                <b>We’re sorry to see you go!</b>
                <p>
                    Once canceled, you will continue to have access
                    to the plan until the end of your billing cycle.
                </p>
            </div>

            <div className={styles.reason}>
                <span>Please select reason for cancellation:</span>
                <div className={styles.reason_list}>
                    {CANCELLATION_REASONS.map(item => <CheckBox
                        key={item.id}
                        text={item.text}
                        checked={selectedReason?.id === item.id}
                        onClick={() => setSelectedReason(item)}
                    />)}

                    {isOtherReason && <Input
                        type='text'
                        value={comment}
                        onChange={setComment}
                        placeholder='please specify'
                    />}
                </div>
            </div>

            {error && <span className={styles.error}>{error}</span>}
        </Modal>
    );
};
